var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal hide-cancel-btn",
      attrs: {
        id: "evaluation-service-gone-modal",
        title: "공지사항",
        "ok-title": _vm.$t("common.confirm")
      },
      on: {
        ok: function($event) {
          return _vm.$emit("ok")
        }
      }
    },
    [
      _c("div", { staticClass: "evaluation-service-gone-container" }, [
        _vm._v(
          "\n안녕하세요 클래스팅 러닝을 사랑해 주시는 선생님들께 진심으로 감사의 말씀을 드립니다."
        ),
        _c("br"),
        _vm._v(
          "\n아쉽게도 8월 1일  자로 클래스팅 러닝 기능 중 '종합의견' 서비스가 종료됩니다."
        ),
        _c("br"),
        _vm._v(
          "\n선생님들께서는 종료  일정을 참고하시어 이용에 불편이 없으시길 바랍니다."
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n다시 한번 '종합의견'을 아껴주셨던 모든 선생님들께 진심으로 감사의 말씀을 드리며,"
        ),
        _c("br"),
        _vm._v(
          "\n향후 더 좋은 서비스로 선생님들을 찾아뵐 수 있도록 노력하겠습니다."
        ),
        _c("br"),
        _c("br"),
        _vm._v("\n\n감사합니다."),
        _c("br"),
        _vm._v("\n클래스팅드림\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d061eb42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d061eb42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/evaluations/components/EvaluationServiceGoneModal.vue
// module id = +6rK
// module chunks = 1